module.exports = __webpack_public_path__ + "img/mirror02.bf954db6.jpg";